import { isExplicitDesiredDate } from 'src/stores/_infrastructure/desiredDateFilter';
import { useFilterListStore } from 'src/stores/filterList';
import { useGenericActivityListStore } from 'src/stores/genericActivityList';
import { RuntimeStoreContext } from 'src/types/runtime/piniaRuntimeContext';

import { DateRangeSelection } from 'src/models/common';
import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { StatusEnum } from 'src/models/status/enums';

import { QueryStore } from 'src/util/query/QueryStore';

const warmupFilterList = (_store: RuntimeStoreContext, queryStore: QueryStore) => {
	const filterListStore = useFilterListStore();

	void filterListStore.fetchFilterBoxes();

	void filterListStore.fetchFilterUsers({
		queryStore: queryStore,
	});
};

const fetchFilterList = (
	_store: RuntimeStoreContext,
	queryStore: QueryStore,
	queryParameters: {
		activityListType: ActivityListTypeEnum;
		clearResultsBeforeFetch: boolean;
		desiredDate: DateRangeSelection | string;
		hiddenSearchTerm: string;
		searchTerm: string;
		view: string;
	}
) => {
	const filterListStore = useFilterListStore();

	if (isExplicitDesiredDate(queryParameters.desiredDate)) {
		filterListStore.setDateFilterAction({
			dateFilter: queryParameters.desiredDate,
		});
	}

	if (queryParameters.clearResultsBeforeFetch) {
		if (queryParameters.activityListType === ActivityListTypeEnum.FILTER) {
			filterListStore.clearSubscriptions({
				queryStore: queryStore,
			});
			filterListStore.silentSetFilterList();
		}
	}

	if (queryParameters.activityListType === ActivityListTypeEnum.FILTER) {
		void filterListStore.fetchFilterList({
			queryStore: queryStore,
			searchTerm: queryParameters.searchTerm,
			view: queryParameters.view,
		});
	}
};

const deleteTheSelectedFilterListAggregateIds = (
	_store: RuntimeStoreContext,
	_queryStore: QueryStore,
	queryParameters: { aggregateIds: string[]; processId: string }
) => {
	const filterListStore = useFilterListStore();
	const genericActivityListStore = useGenericActivityListStore();

	filterListStore.deleteSelectedAggregateIds({
		aggregateIds: queryParameters.aggregateIds,
	});

	void genericActivityListStore.clearTheSelection({
		genericListIdentifier: 'filterList',
	});
};

const setTheStateForTheSelectedFilterAggregateIds = (
	_store: RuntimeStoreContext,
	_queryStore: QueryStore,
	queryParameters: {
		aggregateIds: string[];
		state: StatusEnum;
	}
) => {
	const filterListStore = useFilterListStore();
	const genericActivityListStore = useGenericActivityListStore();

	switch (queryParameters.state) {
		case StatusEnum.UNSEEN:
			filterListStore.setTheFilterStateToUnseen({
				aggregateIds: queryParameters.aggregateIds,
			});
			break;
		case StatusEnum.SEEN:
			filterListStore.setTheFilterStateToSeen({
				aggregateIds: queryParameters.aggregateIds,
			});
			break;
		case StatusEnum.READY:
			filterListStore.setTheFilterStateToReady({
				aggregateIds: queryParameters.aggregateIds,
			});
			break;
		default:
			break;
	}

	void genericActivityListStore.clearTheSelection({
		genericListIdentifier: 'filterList',
	});
};

export {
	deleteTheSelectedFilterListAggregateIds,
	fetchFilterList,
	setTheStateForTheSelectedFilterAggregateIds,
	warmupFilterList,
};
